import { useEffect, useState } from "react";
import { insertSecurityQuestion } from "../../services/adminPanel_service";
import { toast } from "react-toastify";

const SecurityQuestionModal = ({
  show,
  mode = "add",
  initialData = null,
  onClose,
  dataReload
}) => {

  const [selectedQuestionData, setSelectedQuestionData] = useState(null);

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setSelectedQuestionData(initialData);
    }

    if (mode === "add") {
      setSelectedQuestionData({
        "challengePhraseId": 0,
        "challengePhrase": "",
        "challengeAnswerId": 0,
        "isEditable": true,
        "userId": 0,
        "mappedUserId": 0,
        "currentPassword": "",
        "userType": 0,
        "sortOrder": 0
        });
    }
  }, [mode, initialData]);

  if (!show) return null;

  const handleQuestionChange = (e) => {
    setSelectedQuestionData((prev) => ({...prev, challengePhrase:e.target.value}))
  }

  const handleSave = async () => {

    try{
        const response = await insertSecurityQuestion(selectedQuestionData);
        if(response.data === -3){
          toast.error('The question is been used by an answer')
        }
        if(response.data === -2){
          toast.error('The question already exists')
        }
        if(response.data >= 0){
          toast.success('Security question saved successfully.')
        }
        dataReload()
        
    }
    catch{
        toast.error('Unable to save security question')
    }

    onClose();
  };

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>
        <div className="modal-dialog" style={{ width: "650px" }}>
          <div className="modal-content">

            <div className="modal-header" style={{ padding: "0px 0px" }}>
              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                Insert / Update Security Questions
              </h4>
            </div>

            <div className="modal-body">

              <div className="row">
                <div
                  className="col-sm-12"
                  style={{ display: "none", marginTop: "3px" }}
                >
                  <h5 style={{ color: "green" }}></h5>
                  <h5 style={{ color: "red" }}></h5>
                </div>
              </div>

              <div className="form-group">

                <label className="col-sm-4">
                  Security Questions :
                </label>

                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={selectedQuestionData?.challengePhrase}
                    onChange={handleQuestionChange}
                  />
                </div>

              </div>

            </div>

            <div className="modal-footer">

              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save
              </button>

              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>
        </div>
      </div>

      {/* Backdrop intentionally removed */}
      {/*
      <div className="modal-backdrop fade in" onClick={onClose} />
      */}
    </>
  );
};

export default SecurityQuestionModal;